/* Do not edit these strings. They are generated by ptmessages.js.php */
ptMessages = {
    "partnerdownloadbookmark": "Avez-vous d\u00e9j\u00e0 cr\u00e9\u00e9 un signet pour cette page? Appuyez sur <CTRL> + D afin de l'ajouter \u00e0 vos favoris.",
    "applyunload": "Vous n'avez pas encore envoy\u00e9 la commande compl\u00e8te pour l'essai.",
    "equaltocaseinsensitivemsg": "Veuillez r\u00e9p\u00e9ter la m\u00eame valeur.",
    "distanceunitmiles": "Milles",
    "distanceunitkilometers": "Kilom\u00e8tres",
    "distanceperyearlabel": " par an",
    "hours": "heures",
    "priceinterval3": "(paiement tous les 3 mois)",
    "priceinterval12": "(paiement annuel)",
    "priceinterval36": "(paiement tous les 36 mois)",
    "enterprise": "Entreprise",
    "enthintbuymore": "\u00c0 partir de 2 licences repr\u00e9sentants :",
    "enthintusermgmt": "Gestion des utilisateurs centrale",
    "enthintrights": "Gestion des autorisations",
    "enthintorgsettings": "R\u00e9glages pour l'entreprise enti\u00e8re",
    "enthintapi": "Import et export de donn\u00e9es via API",
    "enthintodata": "Analyse de donn\u00e9es via Excel et OData",
    "enthintadmins": "Comptes administrateurs gratuits",
    "shopbuysub": "pour {invoiceamountinclvat} tous les {billinginterval} mois jusqu'\u00e0 r\u00e9siliation",
    "shopvatsub": "Le montant inclut {vatrate}% TVA ({vatamount}).<br\/>Elle sera affich\u00e9e sur la facture.",
    "shopprice": "Prix",
    "shoppriceincurrency": "Prix en {currency}",
    "shopcurrencysub": "Tous les prix en {currency}",
    "shopvatnotapplicable": "{vatamount} TVA ({vatrate}%) sera ajout\u00e9e \u00e0 ma facture.",
    "shopordersumvatsub": "{totalincl} incl. {vatrate}% TVA",
    "shopmindatevalidate": "La date doit \u00eatre \u00e9gale \u00e0 ou plus grande que {2}.",
    "enthintbuyevenmore": "\u00c0 partir de 10 licences repr\u00e9sentants :",
    "enthintusergroups": "Groupes d'utilisateurs",
    "etrackerstatus": "\u00c9tat:",
    "etrackeractive": "etracker est activ\u00e9.",
    "etrackerinactive": "etracker est d\u00e9sactiv\u00e9.",
    "etrackeroptin": "Activer etracker",
    "etrackeroptout": "D\u00e9sactiver etracker",
    "brPhoneErrorMessage": "Veuillez saisir un num\u00e9ro de t\u00e9l\u00e9phone valide (10 chiffres ou plus)",
    "integererror": "N'entrez que des nombres entiers",
    "initvatnrlabel": "No. ID TVA",
    "ptSimpleForm_date": "Veuillez indiquer une date valide",
    "ptSimpleForm_mindate": "La date doit \u00eatre \u00e0 partir de {calculatedMinDate}",
    "ptSimpleForm_noWeekends": "Veuillez s\u00e9lectionner uniquement des jours ouvrables",
    "ibanErrorMessage": "Veuillez indiquer un IBAN valide"
};
